<template>
  <div class="container-fluid col-12 col-lg-10" id="container">

    <div class="calculadora-cabecalho">
      <nav class="breadcrumb-calculadora" style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='%236c757d'/%3E%3C/svg%3E&#34;);" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link to="/" class="text-decoration-none">
            <b class="page-header-eyebrow">Projetos</b>
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link
            :to="`/app/project/${calculo.codProjeto}`"
            class="text-decoration-none"
          >
            <b class="page-header-eyebrow">Projeto</b>
          </router-link>
        </li>    
        <li class="breadcrumb-item active" aria-current="page">Componente</li>
      </ol>
      </nav>
      <div class="badges-calculadora">
        <span class="azul badge bg-primary"><b>Data de Criação: {{ converterDataBrasil(calculo.dataCriacao) }}</b></span>
        <span class="azul badge bg-primary"><b>Autor(a): {{ abreviarNome(calculo.autor) }}</b></span>
      </div>
    </div>

    <section class="calculadora-resumo">
      <!-- TÍTULO -->
      <div class="calculadora-identificacao">
        <p class="page-header-eyebrow">COMPONENTE DE FLANGE</p>
        <h1 class="calculadora-titulo">{{ calculo.nomeCalculo }}</h1>
        <p class="calculadora-subtitulo">
          Calculadora: <strong>{{ calculo.nomeCalculadora }}</strong>
        </p>
      </div>

      <figure class="calculadora-ilustracao">
        <img
          src="../componentes/img/6.png"
          alt="Desenho do Componente"
          class="img-componente-calc"
        />
        <figcaption>Ilustração do componente</figcaption>
      </figure>
    </section>

    <section class="calculadora-impressao">
      <div>
        <h2>Imprimir componente</h2>
        <p>Imprime um PDF com todos os dados do componente.</p>
      </div>
      <button type="button" class="btn btn-secundario" @click="imprimir()">
        Imprimir
      </button>
    </section>

    <!-- BOTÕES DE AÇÃO -->
    <div class="row g-2 justify-content-end">

      <!-- CALCULAR -->
      <div class="col-12 col-md-auto">
        <button
          type="button"
          class="botao-azul btn btn-primary w-100"
          @click="calcular"
        >
          Calcular
        </button>
      </div>

      <!-- SALVAR -->
      <div class="col-6 col-md-auto">
        <button
          class="botao-azul btn btn-primary w-100"
          @click="salvarCalculo()"
        >
          Salvar
        </button>
      </div>

    </div>

    <FlangeIntegralCalculatorComponent :flangeIntegralCalculatorProps="flangeIntegralCalculator" :designData="designData" ref="flangeIntegralCalculatorForm" @temperatura-fora-faixa="abrirAlertaTemperaturaForaFaixa"/>
    
    <!-- BOTÕES DE AÇÃO -->
    <div class="row g-2 justify-content-end">

      <!-- CALCULAR -->
      <div class="col-12 col-md-auto">
        <button
          type="button"
          class="botao-azul btn btn-primary w-100"
          @click="calcular"
        >
          Calcular
        </button>
      </div>

      <!-- SALVAR -->
      <div class="col-6 col-md-auto">
        <button
          class="botao-azul btn btn-primary w-100"
          @click="salvarCalculo()"
        >
          Salvar
        </button>
      </div>

    </div>

    <!-- MODAIS -->
    <AlertModal
      :visible="alertModal.visible"
      :title="alertModal.title"
      :message="alertModal.message"
      :type="alertModal.type"
      @close="fecharAlert"
    />

    <LoadingModal
      :visible="loading.visible"
      :title="loading.title"
      :message="loading.message"
    />

  </div>
</template>

<script>
import { getUsuario } from '@/utils/authStorage';
// Componentes
import FlangeIntegralCalculatorComponent from '@/components/calculadoras/FlangeIntegralCalculatorComponent.vue';
import DesignData from '@/models/calculadoras/DesignData.js';
import FlangeIntegralCalculator from '@/models/calculadoras/FlangeIntegralCalculator.js';
import AlertModal from '@/componentesTelas/AlertModal.vue';
import LoadingModal from '@/componentesTelas/LoadingModal.vue';
import { logoBase64 } from './imgBase64/logoBase64.js';
import { drawingFlangeIntegralBase64 } from './imgBase64/drawingFlangeIntegralBase64.js';
import { jsPDF } from "jspdf";

export default {
  name: "CalculatorFlangeIntegral",
  props: ["cod"],
  data() {
    return {
      calculo: {},
      designData: new DesignData(),
      flangeIntegralCalculator: new FlangeIntegralCalculator(),
      SFO: 0,
      usuarioLogado: null,

      // Modal de loading
      loadingModal: null,
      loadingModalAberto: false,

      // Modal de loading
      loading: {
        visible: false,
        title: 'Carregando dados',
        message: 'Aguarde um momento...'
      },

      // Modal genérico
      alertModal: {
        visible: false,
        title: '',
        message: '',
        type: 'info'
      },
    };
  },
  components: {
    FlangeIntegralCalculatorComponent,
    AlertModal,
    LoadingModal
  },
  mounted(){
    const usuarioSalvo = getUsuario();
    this.usuarioLogado = usuarioSalvo ? {
      ...usuarioSalvo,
      nome: usuarioSalvo.nome
    } : null;
    this.topoPagina();
    this.abrirLoading();
    this.carregarCalculo(this.cod);
  },
  created(){
    window.scrollTo(0, 0);
    this.topoPagina();
  },
  updated(){
    setTimeout(() => {
      this.topoPagina();
    }, 1);
  },
  methods: {
    
    abrirAlert(title, message, type = 'info') {
      this.alertModal = {
        visible: true,
        title,
        message,
        type
      };
    },

    abrirAlertaTemperaturaForaFaixa({ temperatura, minimo, maximo }) {
      this.abrirAlert(
        "Sistema",
        `A temperatura informada (${temperatura} °C) esta fora do intervalo permitido (${minimo} °C a ${maximo} °C).`,
        "warning"
      );
    },

    fecharAlert() {
      this.alertModal.visible = false;
    },

    abrirLoading() {
      this.loading.visible = true;
    },

    fecharLoading() {
      this.loading.visible = false;
    },

    calcular(){
      const form = this.$refs.flangeIntegralCalculatorForm.$refs.formCalculo;

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      if (!this.flangeIntegralCalculator.materialSpecification || !this.flangeIntegralCalculator.materialSpecification.materialSpecification) {
        form.querySelector('input[type="search"]')?.focus();
        return;
      }

      if (!this.flangeIntegralCalculator.bolt || !this.flangeIntegralCalculator.gasket) {
        form.querySelector('select:not([required])')?.focus();
        return;
      }

      // Dispara o submit do form
      form.requestSubmit();

      this.abrirAlert("Sistema", "Cálculos realizados com sucesso.", "success");
    },

    verResultados() {
      // Scroll para os resultados
      this.$nextTick(() => {
        const el = document.getElementById('calculation-results');
        if (el) {
          el.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    },

    abreviarNome(nome) {
      if (!nome) return '';

      const partes = nome
        .trim()
        .split(' ')
        .filter(Boolean); // 🔑 remove strings vazias

      if (partes.length === 1) return partes[0];

      return `${partes[0]} ${partes[partes.length - 1]}`;
    },

    converterDataBrasil(data) {
      if (!data) return '';

      const partes = data.split('-');
      if (partes.length !== 3) return data;

      return `${partes[2]}/${partes[1]}/${partes[0]}`;
    },

    topoPagina() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },

    async carregarDesignDataPorCod(codProjeto) {
      try {
          const response = await fetch(
              `${process.env.VUE_APP_BACKEND_URL}/buscar-design-data/${codProjeto}`,
              {
                  method: "GET",
                  headers: { "Content-Type": "application/json" }
              }
          );

          if (!response.ok) {
              throw new Error("Design Data não encontrado");
          }

          const data = await response.json();

          // mantém a instância da classe DesignData
          Object.assign(this.designData, data.designData.designData);

          // Copia campos do design data
          this.flangeIntegralCalculator.designPressureInternal = this.designData.designInternalPressure;
          this.flangeIntegralCalculator.designTemperature = this.designData.designTemperature;
          this.flangeIntegralCalculator.corrosionAllowance = this.designData.corrosionAllowance;

      } catch (error) {
          console.error("Erro ao carregar Design Data:", error);
      }
    },

    async carregarShellAllowStressElementoPai() {

      try {
        const response = await fetch(
          `${process.env.VUE_APP_BACKEND_URL}/buscar-shell-allow-stress-elemento-pai/${this.calculo.elementoPaiCod}`,
          {
            method: "GET",
            headers: { "Content-Type": "application/json" }
          }
        );

        if (!response.ok) {
          throw new Error("Shell Allow Stress não encontrado");
        }

        const data = await response.json();

        this.flangeIntegralCalculator.shellAllowStress = data.admissibleStressDesignTemp;

      } catch (error) {
        console.error("Erro ao carregar Shell Allow Stress:", error);
      }
    },

    salvarCalculo() {
      let calculo = {
        cod: this.cod,
        flangeIntegralCalculator: this.flangeIntegralCalculator,
      };

      fetch(`${process.env.VUE_APP_BACKEND_URL}/salvar-calculo`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ calculo }),
        mode: 'cors',
      })
        .then(response => response.json())
        .catch(error => {
          console.error('Erro ao enviar dados para o servidor:', error);
        });
        this.abrirAlert("Sistema", "Dados salvos com sucesso.", "info");
        this.topoPagina();
        // this.carregarCalculo(this.cod);
    },

    carregarCalculo(cod) {

      fetch(
        `${process.env.VUE_APP_BACKEND_URL}/buscar-calculo/${cod}?email=${this.usuarioLogado.email}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
          mode: "cors",
        }
      )
        .then((response) => {

          // 🔐 BACKEND decide o acesso
          if (response.status === 401 || response.status === 403) {
            window.location.href = '/';
            throw new Error('Acesso negado');
          }

          if (!response.ok) {
            throw new Error('Erro ao carregar cálculo');
          }

          return response.json();
        })
        .then((data) => {
          if (!data || !data.calculo) {
            console.error("Resposta inválida do servidor:", data);
            return;
          }

          // 1️⃣ CÁLCULO
          Object.assign(this.calculo, data.calculo);

          // 2️⃣ DADOS ESPECÍFICOS DO CALCULADOR
          Object.assign(
            this.flangeIntegralCalculator,
            data.calculo.flangeIntegralCalculator
          );

          // 3️⃣ DESIGN DATA PELO PROJETO
          this.carregarDesignDataPorCod(this.calculo.codProjeto);

          this.carregarShellAllowStressElementoPai(this.calculo.elementoPaiCod);

          this.topoPagina();
        })
        .catch((error) => {
          console.error("Erro ao carregar dados do cálculo:", error);
        })
        .finally(() => {
          this.fecharLoading();
        });
    },

    adicionarPaginacao(doc) {
      const totalPaginas = doc.internal.getNumberOfPages();
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.height;

      for (let i = 1; i <= totalPaginas; i++) {
        doc.setPage(i);
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        doc.setTextColor(150);

        const texto = `Página ${i} de ${totalPaginas}`;
        const textWidth = doc.getTextWidth(texto);
        doc.text(texto, (pageWidth - textWidth) / 2, pageHeight - 10);

        doc.setTextColor(0);
      }
    },

    async imprimir() {
      this.loading = {
        visible: true,
        title: 'Gerando PDF',
        message: 'Aguarde enquanto o documento e preparado...'
      };
      await this.$nextTick();
      await new Promise(resolve => requestAnimationFrame(resolve));

      const doc = new jsPDF();

      /* =========================
        FONTES
      ========================== */
      const pageHeight = doc.internal.pageSize.height;
      const pageWidth = doc.internal.pageSize.getWidth();
      let y = 20;

      /* =========================
        PAGE BREAK
      ========================== */
      const checkPage = (extra = 10) => {
        if (y + extra >= pageHeight - 20) {
          doc.addPage();
          y = 20;
        }
      };

      /* =========================
        HELPERS
      ========================== */
      const title = (text) => {
        checkPage(20);
        doc.setFont("helvetica", "bold");
        doc.setFontSize(16);
        doc.text(text, 20, y);
        y += 14;
      };

      const field = (label, value, unit = "") => {
        checkPage();

        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        doc.text(label, 20, y);

        let x = 20 + doc.getTextWidth(label);

        doc.setFont("helvetica", "normal");
        doc.text(":", x, y);
        x += doc.getTextWidth(": ");

        doc.text(`${value ?? "N/A"}${unit}`, x + 2, y);

        y += 10;
      };

      const message = (text) => {
        checkPage();
        doc.setFont("helvetica", "italic");
        doc.setFontSize(14);
        doc.setTextColor(120);
        doc.text(text, 20, y);
        doc.setTextColor(0);
        y += 7;
      };

      const subtitle = (text) => {
        checkPage();
        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        doc.text(text, 20, y);
        y += 10;
      };

      /* =========================
        HEADER
      ========================== */
      const logoW = 55;
      const logoH = 12;
      const logoX = (pageWidth - logoW) / 2;

      doc.addImage(logoBase64, "PNG", logoX, y, logoW, logoH);
      doc.link(logoX, y, logoW, logoH, {
        url: "https://wisecalc.com.br",
      });
      
      y += logoH + 25;

      doc.setFont("helvetica", "bold");
      doc.setFontSize(18);
      doc.text("Flange Calculation – ASME VIII DIV.1", 20, y);
      y += 14;

      field("Nome do Componente", this.calculo.nomeCalculo);
      field("Tipo de Calculadora", this.calculo.nomeCalculadora);
      field("Autor(a)", this.calculo.autor || "N/A");

      field(
        "Data da Impressão",
        new Date().toLocaleDateString("pt-BR", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        })
      );

      y += 10;

      const f = this.flangeIntegralCalculator;

      /* =========================
        1. PRE-CONFIGURATION
      ========================== */
      title("1. PRE-CONFIGURATION");
      field("Overbolting", "", f.overboltingSelect === "1" ? "Yes" : "No");
      field("Replace B by B1", "", f.bSelect === "1" ? "Yes" : "No");

      /* =========================
        2. FLANGE MATERIAL
      ========================== */
      y += 10;
      title("2. FLANGE MATERIAL");
      field("Flange Material", "", f.flangeMaterial);
      field("Bolt Material", "", f.boltMaterial);
      field("Gasket", "", f.gasket);

      /* =========================
        3. DESIGN DATA
      ========================== */
      y += 10;
      title("3. DESIGN DATA");
      field("Design Pressure (Internal)", "P", f.designPressureInternal, "MPa");
      field("Design Temperature", "Tp", f.designTemperature, "°C");
      field("Corrosion Allowance", "c", f.corrosionAllowance, "mm");
      field("Shell Allowable Stress", "Sn", f.shellAllowStress, "N/mm²");
      field("At Atmospheric Temp", "Sna", f.atmosphericTemp, "N/mm²");

      /* =========================
        4. FLANGE ALLOWABLE STRESS
      ========================== */
      y += 10;
      title("4. FLANGE ALLOWABLE STRESS");
      field("At Design Temp", "Sfo", f.sfo, "N/mm²");
      field("At Atmospheric Temp", "Sfa", f.sfa, "N/mm²");

      /* =========================
        5. BOLTING ALLOWABLE STRESS
      ========================== */
      y += 10;
      title("5. BOLTING ALLOWABLE STRESS");
      field("At Design Temp", "Sbo", f.sbo, "N/mm²");
      field("At Atmospheric Temp", "Sba", f.sba, "N/mm²");

      /* =========================
        6. FLANGE
      ========================== */
      y += 10;
      title("6. FLANGE");
      field("OD Flange", "A", f.odFlange, "mm");
      field("ID Flange", "B", f.idFlange, "mm");
      field("Center Bolt Diameter", "C", f.centerBoltDiameter, "mm");
      field("Load Reaction Gasket Diameter", "G", f.loadReactionGasketDiameter, "mm");
      field("Thickness Hub Small End", "g0", f.thicknessHubSmallEnd, "mm");
      field("Thickness Hub Back", "g1", f.thicknessHubBack, "mm");
      message("B > 20 g1");
      field("Hub Length", "h", f.hubLength, "mm");
      field("R", "R", f.R, "mm");
      field("f", "f", f.f);
      message("B = B1 + g1");
      field("B1", "B1", f.b1);
      message("Não será utilizado p/ calcular SH");
      field("Minimum Gasket Width", "Nmin", f.larguraMinimaJunta, "mm");

      /* =========================
        7. BOLTING
      ========================== */
      y += 10;
      title("7. BOLTING");
      field("Bolt Diameter", "d", f.boltDiameter, "in");
      field("Pitch Diameter", "Dp", f.pitchDiameter);
      field("Bolts Quantity", "n", f.boltsQuantity);
      field("Stress Area", "", f.rootDiameter, "mm²");
      field("Friction Factor", "", f.frictionFactor);
      field("Minimum Torque", "", f.torqueMinimo, "N·m");
      field("Maximum Torque", "", f.torqueMaximo, "N·m");

      /* =========================
        8. GASKET
      ========================== */
      y += 10;
      title("8. GASKET");
      field("OD Gasket", "", f.odGasket, "mm");
      field("ID Gasket", "", f.idGasket, "mm");
      field("Max Gasket Crushing Pressure", "", f.gasketCrushingPressure, "N/mm²");
      field("Ag", "", f.Ag, "mm²");
      field("Sya", "", f.Sya, "N/mm²");
      field("Sys", "", f.Sys, "N/mm²");
      field("Result Gasket", "", f.resultGasket);

      /* =========================
        9. PARAMETERS
      ========================= */
      y += 10;
      title("9. PARAMETERS");

      field("(od - id) / 2", "N", f.N, "mm");
      field("N / 2", "b0", f.b0, "mm");
      field("min.(b0, 2.5√(b0 × 1/2))", "b", f.b, "mm");
      field("Gasket factor", "y", f.y, "N/mm²");
      field("m factor", "m", f.m);
      
      /* =========================
        10. CALCULATED VALUES
      ========================= */
      y += 10;
      title("10. CALCULATED VALUES");

      field("3.14 b G y", "Wm2", f.Wm2, "N");
      field("6.28 b G m p", "Hp", f.Hp, "N");
      field("0.785 G² p", "H", f.H, "N");
      field("Hp + H", "Wm1", f.Wm1, "N");
      field("max(Wm2/Sba, Wm1/Sbo)", "Am", f.Am, "mm²");
      field("Bolts qty × root area", "Ab", f.Ab, "mm²");
      field("(Am + Ab) × Sba / 2", "W1", f.W1, "N");
      field("(Ab × Sba)", "W2", f.W2, "N");
      field("max(W1, W2)", "W", f.W, "N");

      /* =========================
        11. OPERATING CONDITIONS
      ========================= */
      y += 10;
      title("11. OPERATING CONDITIONS");

      subtitle("FLANGE LOADS");
      y += 5;

      field("0.785 B² P", "Hd", f.Hd, "N");
      field("W - H", "Hg", f.Hg, "N");
      field("H - Hd", "Ht", f.Ht, "N");

      y += 5;
      subtitle("LEVER ARMS");
      y += 5;

      field("R + 0.5 g1", "hd", f.hd, "mm");
      field("(C - G) / 2", "hg", f.hg, "mm");
      field("(R + g1 + hg) / 2", "ht", f.ht, "mm");

      y += 5;
      subtitle("FLANGE MOMENTS");
      y += 5;

      field("Hd × hd", "Md", f.Md, "N·mm");
      field("Hg × hg", "Mg", f.Mg, "N·mm");
      field("Ht × ht", "Mt", f.Mt, "N·mm");
      field("Md + Mg + Mt", "Mop", f.Mop, "N·mm");

      /* =========================
        12. ATMOSPHERIC CONDITIONS
      ========================= */
      y += 10;
      title("12. ATMOSPHERIC CONDITIONS");

      subtitle("FLANGE LOAD");
      y += 5;

      field("W", "Hg", f.Hg2, "N");

      y += 5;
      subtitle("LEVER ARM");
      y += 5;

      field("(C - G) / 2", "hg", f.hg2, "mm");

      y += 5;
      subtitle("FLANGE MOMENT");
      y += 5;

      field("Hg × hg", "Matm", f.Matm, "N·mm");

      y += 5;
      subtitle("TOTAL MOMENTS ON FLANGE");
      y += 5;

      field("Bolt correction factor", "CF", f.CF);
      field("Moment at operative condition (Mop × CF / B)", "Mo", f.Mo, "N·mm");
      field("Moment at atmospheric condition (Matm × CF / B)", "Ma", f.Ma, "N·mm");

      /* =========================
        13. SHAPE CONSTANTS
      ========================= */
      y += 10;
      title("13. SHAPE CONSTANTS");

      field("A / B", "K", f.K);
      field("fig. 2-7.1", "T", f.T);
      field("fig. 2-7.1", "Z", f.Z);
      field("Y", "Y", f.Y);
      field("U", "U", f.U);
      field("g1 / g0", "g1g0", f.g1g0);
      field("sqrt(B g0)", "h0", f.h0);
      field("h / h0", "hh0", f.hh0);
      field("fig. 2-7.2", "F", f.F);
      field("fig. 2-7.3", "V", f.V);
      field("fig. 2-7.6", "f", f.fShape);
      field("F / h0", "e", f.e);
      field("(U / V) h0 g0²", "d", f.d);
      field("t", "t", f.t);
      field("β = (1.33 t e + 1)", "beta", f.beta);
      field("(t e + 1) / T + (3 / d)", "L", f.L);

      /* =========================
        14. STRESS CALCULATIONS
      ========================= */
      y += 10;
      title("14. STRESS CALCULATIONS");

      subtitle("OPERATING CONDITION");
      y += 5;

      field("Longitudinal hub stress SH = (f Mo) / (L t² B)", "SH", f.SH_operating, "MPa");
      field("Radial flange stress SR = (β Mo) / (L t² B)", "SR", f.SR_operating, "MPa");
      field("Tangent flange stress ST = (y Mo) / (t² B) - Z SR", "ST", f.ST_operating, "MPa");
      field("Max of 0.5 × (SH + SR) or 0.5 × (SH + ST)", "Smax", f.Smax_operating, "MPa");

      y += 5;
      subtitle("AMBIENT CONDITION");
      y += 5;

      field("Longitudinal hub stress SH (ambient)", "SH", f.SH_ambient, "MPa");
      field("Radial flange stress SR (ambient)", "SR", f.SR_ambient, "MPa");
      field("Tangent flange stress ST (ambient)", "ST", f.ST_ambient, "MPa");
      field("Max of 0.5 × (SH + SR) or 0.5 × (SH + ST)", "Smax", f.Smax_ambient, "MPa");

      y += 5;
      subtitle("DRAWING");

      const drawingWidth = 100;
      const drawingHeight = 80;
      const drawingX = (pageWidth - drawingWidth) / 2;

      checkPage(drawingHeight + 20);
      doc.addImage(drawingFlangeIntegralBase64, "PNG", drawingX, y, drawingWidth, drawingHeight);

      this.adicionarPaginacao(doc);
      doc.save(`(WISECALC) ${this.calculo.nomeCalculo}.pdf`);
      this.fecharLoading();
    }

  }
};
</script>

<style scoped>
.documento {
  width: 210mm;
  min-height: 297mm;
  padding: 20mm;
  background: white;
  font-family: 'Arial', sans-serif;
  font-size: 14px;
  position: relative;
  box-sizing: border-box;
}

.cabecalho {
  text-align: center;
  border-bottom: 2px solid #000;
  margin-bottom: 20px;
}

.cabecalho .logo {
  width: 80px;
  margin-bottom: 10px;
}

.conteudo {
  margin-top: 20px;
}

.conteudo p {
  margin-bottom: 10px;
}

.rodape {
  position: absolute;
  bottom: 20mm;
  left: 0;
  width: 100%;
  text-align: center;
  font-size: 12px;
  color: gray;
  border-top: 1px solid #ccc;
  padding-top: 5px;
}

.botao-outline-azul{
  border-color: #0056FF;
  background-color: white;
  color: #0056FF;
  font-weight: 600;
  height: 40px !important;
}

.botao-outline-azul:hover{
  border-color: #0056FF;
  background-color: #0056FF;
  color: white;
  font-weight: 600;
}

.img-componente-calc{
  width: 150px;
}

/* APENAS CELULAR */
@media (max-width: 575px) {
    .input {
        width: 150px;
    }

    .form-select{
        display: block !important;
    }

    .img-componente-calc{
      width: 150px;
    }
}

/* TABLET */
@media (min-width: 768px) and (max-width: 991px) {
    .img-componente-calc{
      width: 125px;
    }
}
</style>